<template>
    <div class="connections-page">
        <div>
            <div class="title-button">
                <div class="container" v-if="!getShowProfileData">
                    <div class="row">
                        <div class="col-md-12 col-lg-4">
                            <h2>Conexões</h2>
                        </div>

                        <div class="col-md-12 col-lg-8">
                            <div class="right-buttons">
                                <b-input-group class="search-field right-space">
                                    <b-input-group-prepend>
                                        <b-icon icon="search" aria-hidden="true"></b-icon>
                                    </b-input-group-prepend>

                                    <b-form-input
                                        placeholder="Pesquisar por nome"
                                        v-model="searchFieldText"
                                    ></b-form-input>
                                </b-input-group>

                                <b-button
                                    :variant="filterByConnections ? 'dark' : 'white'"
                                    size="sm"
                                    class="mb-2 right-space"
                                    @click="changeStatusConnection(true)"
                                >
                                    Conexões
                                </b-button>

                                <b-button
                                    :variant="!filterByConnections ? 'dark' : 'white'"
                                    size="sm"
                                    class="mb-2 btn-solutions"
                                    @click="changeStatusConnection(false)"
                                >
                                    Solicitações pendentes
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="profile-data" v-if="getShowProfileData">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="back-btn font-14" @click="backFromSeeProfile()">Voltar</div>
                        </div>
                    </div>
                </div>

                <div>
                    <MyProfile
                        :profileData="profileData"
                        :profileTitle="getMyProfileTitle"
                        :isPending="true"
                        :isPlatform="true"
                        :isOutsideData="true"
                    />
                </div>
            </div>
        </div>

        <div class="container" v-if="!getShowProfileData">
            <div class="connections-cards">
                <div class="row">
                    <div class="col-md-6 col-lg-4" :key="index" v-for="(item, index) in getConnectionsFiltered">
                        <ConnectionCardPP
                            :name="item.name"
                            :isConnection="filterByConnections"
                            :ods="item.ods"
                            :area="item.principal_area_atuacao"
                            :city="item.cidade"
                        >
                            <template v-slot:footer-buttons>
                                <b-button
                                    :variant="!getIsDarkTheme ? 'dark' : 'white'"
                                    @click="setShowProfileData(item)"
                                    >Ver mais</b-button
                                >
                            </template>
                        </ConnectionCardPP>
                    </div>
                </div>
            </div>
        </div>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import ConnectionCardPP from '@/ui/connection-card-pp/ConnectionCardPP'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import MyProfile from '@/components/my-profile/MyProfile'
import { PlatformApi } from '../../../../api/platform'
import { AuthenticationApi } from '../../../../api/authentication'

const platformApi = new PlatformApi()
const authenticationApi = new AuthenticationApi()

export default {
    components: { ConnectionCardPP, InfiniteLoading, DangerModalPP, MyProfile },
    data() {
        return {
            searchFieldText: '',
            idUserLogged: null,
            filterByConnections: true,
            currentRouterName: null,
            myProfileTitle: '',
            message: null,
            profileData: {},
            showProfileData: false,
            connections: [],
            connectionsFiltered: [],
            page: 1
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProfileAllData', 'setOpenProfileComp']),
        fetch() {
            this.profileData = {
                starsNumber: 0,
                profileName: '',
                initiativeDescription: '',
                email: '',
                city: 'São Paulo - SP',
                partners: [],
                connectionsNumber: 0,
                evaluationNumber: 0,
                selectedStatus: [1, 2, 3, 4, 5, 6, 7, 8, 9]
            }

            this.setIsLoading(true)

            authenticationApi
                .getUser()
                .then(response => {
                    this.idUserLogged = response.data.id

                    if (this.getOpenProfileComp) {
                        this.setShowProfileData({ id_user: Number(this.getProfileData.userId) })
                        this.setOpenProfileComp(false)
                        this.setProfileAllData(null)
                    } else {
                        platformApi
                            .getMyConnections()
                            .then(response => {
                                if (response.data.data) {
                                    const data = response.data.data
                                    this.connections = this.filterByConnections ? data.Conectado : data.Pendente
                                }
                            })
                            .catch(error => {
                                this.message = error.response.data.message
                                this.$refs.warningModal.showModal()
                            })
                            .finally(() => {
                                this.setIsLoading(false)
                            })
                    }
                })
                .catch(error => {
                    this.setIsLoading(false)
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
        },
        changeStatusConnection(status) {
            this.filterByConnections = status
            this.fetch()
        },
        backFromSeeProfile() {
            this.changeRegisterForm('FirstInformationForm1')
            this.profileData = {}
            this.showProfileData = false
            this.fetch()
        },
        getOrganizationProfile(data) {
            if (data.id_organizacao === 1 && data.prestador_servico === 0) {
                return 'Iniciativa'
            } else if (data.id_organizacao === 1 && data.prestador_servico) {
                return 'Prestador de Serviço'
            } else if (data.id_organizacao === 2) {
                return 'Investidor'
            }
        },
        setShowProfileData(data) {
            this.changeRegisterForm('FirstInformationForm1')

            this.setIsLoading(true)

            platformApi
                .getAllProfileData(data.id_user)
                .then(response => {
                    if (response.data.data) {
                        const data = response.data.data
                        this.profileData.allData = data
                        this.profileData.starsNumber = data.Estrela
                        this.profileData.email = data.PrimeirasInformacao.email
                        this.profileData.profileName = data.PrimeirasInformacao.nome_organizacao
                        this.profileData.initiativeDescription = data.PrimeirasInformacao.descricao_organizacao
                        this.profileData.partners = data.PrimeirasInformacao.ods
                        this.profileData.connectionsNumber = data.Conexao
                        this.profileData.evaluationNumber = data.TotalAvaliacao
                        this.profileData.compatibility = data.Compatibilidade
                        this.profileData.idUserLogged = this.idUserLogged
                        this.showProfileData = true

                        const info = {
                            id_organizacao: data.PrimeirasInformacao.id_organizacao,
                            prestador_servico: data.PrimeirasInformacao.prestador_servico
                        }

                        this.myProfileTitle = `Perfil da organização (${this.getOrganizationProfile(info)})`
                        this.scrollBehavior()
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
        },
        scrollBehavior() {
            const ele = document.getElementById('app')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        }
    },
    computed: {
        getConnectionsFiltered() {
            if (this.searchFieldText) {
                return this.connections.filter(res =>
                    res.name.toLowerCase().includes(this.searchFieldText.toLowerCase())
                )
            } else {
                return this.connections
            }
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getMyProfileTitle() {
            return this.myProfileTitle
        },
        getShowProfileData() {
            return this.showProfileData
        },
        getProfileData() {
            return this.$store.state.profileAllData
        },
        getOpenProfileComp() {
            return this.$store.state.openProfileComp
        }
    },
    watch: {
        $route(to, from) {
            if (to.name !== this.currentRouterName) {
                this.currentRouterName = to.name
                this.fetch()
            }
        }
    },
    mounted() {
        this.currentRouterName = this.$router.history.current.name
        const routeParams = this.$router.history.current.params
        const paramsKeys = Object.keys(routeParams)

        if (paramsKeys.length) {
            if (this.currentRouterName === 'NewRequestEmailConnectionPage') {
                this.setIsLoading(true)
                const data = { id: routeParams.userId, compatibilidade: routeParams.compatibility }

                platformApi
                    .setRequestConnection(data)
                    .then(response => {
                        this.setProfileAllData({ userId: routeParams.userId })
                        this.setOpenProfileComp(true)
                        this.$router.push({ name: 'ConnectionsPage' })
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                        this.$router.push({ name: 'ConnectionsPage' })
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            } else if (this.currentRouterName === 'CancelRequestEmailConnectionPage') {
                this.setIsLoading(true)
                const data = { id: routeParams.connectionId, option: routeParams.opt }

                platformApi
                    .answerConnection(data)
                    .then(response => {
                        this.setProfileAllData({ userId: routeParams.userId })
                        this.setOpenProfileComp(true)
                        this.$router.push({ name: 'ConnectionsPage' })
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                        this.$router.push({ name: 'ConnectionsPage' })
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        } else {
            this.fetch()
        }
    }
}
</script>

<style scope src="./ConnectionsPage-light-theme.css"></style>
<style scope src="./ConnectionsPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-page/connections-page/ConnectionsPage.vue